import { render, staticRenderFns } from "./tap-to-top.vue?vue&type=template&id=11f7871b&"
import script from "./tap-to-top.vue?vue&type=script&lang=js&"
export * from "./tap-to-top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports